const defaultSettings = {
    sheetID: '',
    range: '',
    useHeaders: "true",
    gsheetsApiPath: "https://host.daytondailynews.com/cop/digital/tools/google_sheets_api/endpoints/get_sheet_data.php"
}

export class GoogleSheetsClass {

    constructor(settings = {}) {
        Object.assign(this, defaultSettings, settings);
    }

    createGoogleSheetsUrl() {
        // INIT
        const vm = this;

        // CHECK FOR REQUIRED PROPERTIES
        if(vm.sheetID && vm.range && vm.gsheetsApiPath) {
            // INIT FINAL API URL
            let gsheetsUrl = vm.gsheetsApiPath;

            // ADD SHEET ID
            gsheetsUrl += "?sheetid="+vm.sheetID;

            // ADD RANGE
            gsheetsUrl += "&range=" + encodeURIComponent(vm.range);

            // ADD "USEHEADERS"
            gsheetsUrl += "&use_headers="+vm.useHeaders;

            // RETURN FINAL API URL
            return gsheetsUrl;
        }
        else {
            console.log('missing required Google Sheets properties. Check class file for reference.');
            return false;
        }

        
    }

}